import { MapPinOff } from 'lucide-react';
import { cn } from '@/lib/utils';
import { STATUS_COLOR_CLASS } from '@/styles/statusColors';

interface NoGpsBadgeProps {
  className?: string;
}

export function NoGpsBadge({ className }: NoGpsBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full px-1.5 py-px text-2xs font-medium',
        STATUS_COLOR_CLASS.danger,
        className,
      )}
    >
      <MapPinOff className="size-3" aria-hidden />
      No GPS
    </span>
  );
}
